<template>
  <div class="page my-number-upload" style="overflow: hidden;">
    <div class="col-sm-12" style="padding-left: 0px;padding-right: 0px">
      <h4 class="title-upload">
        <span>{{ $t("trs.front.crypto.document.title") }}</span>
      </h4>
    </div>
    <div class="status_submission">
      <span>{{ $t("trs.front.crypto.upfile.doc.status") }}</span>
      <ul v-if="this.isCustomerIndividual" style="padding-left: 0;list-style-position: inside">
        <li>{{ $t("trs.front.crypto.upfile.id.status") }}</li>
        <li v-if="enableUploadMyNumberDoc">{{ $t("trs.front.crypto.upfile.mynumber.docs") }}</li>
      </ul>
      <ul v-if="this.isCustomerCorp" style="padding-left: 0;list-style-position: inside">
        <li>{{ $t("trs.front.crypto.upfile.personal.transaction.docs") }}</li>
        <li>{{ $t("trs.front.crypto.upfile.personal.certificate.history.docs") }}</li>
        <li v-if="enableUploadMyNumberDoc">{{ $t("trs.front.crypto.upfile.Corporate.mynumber.notice") }}</li>
      </ul>
    </div>

    <div class="alert alert-success alert-dismissible margin-top-sp" v-if="this.successMessage">
      <div><span v-html="$t(this.successMessage)"></span></div>
    </div>
    <div class="alert alert-danger alert-dismissible margin-top-sp" v-if="this.errorMessage">
      <div><span>{{ $t(this.errorMessage) }}</span></div>
    </div>

    <div class="margin-top-sp col-sm-12">
      <a :href="supportDocumentUrl" target="_blank" class="fright" style="color: #0078ca;cursor: pointer;">
        <i class="far fa-question-circle"></i> {{ $t("trs.front.crypto.upfile.need") }}
      </a>
    </div>

    <div class="clearfix" style="margin-bottom: 10px"></div>

    <ul class="tabs-submission">
      <li v-bind:class="activeTab === 0 ? 'active' : ''" rel="upFileTab1" @click="updateActiveUploadFileTab(0)">
        {{ $t("trs.front.crypto.upfile.tab1") }}
      </li>
      <li v-bind:class="activeTab === 1 ? 'active' : ''" rel="upFileTab2" @click="updateActiveUploadFileTab(1)">
        {{ $t("trs.front.crypto.upfile.tab2") }}
      </li>
    </ul>

    <div id="upFileTab1" v-show="activeTab === 0" class="accordion">
      <div v-if="isCustomerIndividual">
        <h4><span>{{ $t("trs.front.crypto.upfile.id.form") }}</span></h4>

        <!-- Identity Verification Docs -->
        <div id="uploadIdDocIndivPanel" class="panel-group card" :class="showUploadIdDoc ? 'open' : ''">
          <div class="panel-heading card-header"
               @click="toggleShowUploadIdDocFlg()"
               data-toggle="collapse" data-target="#uploadIdDocIndivPanelBody"
               aria-expanded="true" aria-controls="uploadIdDocIndivPanelBody">
            <i class="icon icon-upload"></i>
            <label>
              <strong>{{ $t("trs.front.crypto.upfile.on.web") }}</strong>
            </label>
            <i class="icon-arrow"></i>
          </div>

          <div id="uploadIdDocIndivPanelBody" class="panel-body collapse" style="padding: 20px 0px 0px 0px" data-parent="#upFileTab1">
            <div class="card-body">
              <div style="margin-bottom: 20px">{{ $t("trs.front.crypto.upfile.file.extension") }}</div>
              <form name="upload_file" novalidate @submit.prevent="uploadIdDocIndiv()">
                  <div class="form-group row">
                    <label class="control-label col-sm-3 col-form-label">{{ $t("trs.front.crypto.upfile.select.file") }}</label>
                    <div class="col-sm-9">
                      <FileInput v-model="$v.idDocIndiv1.$model" name="idDocIndiv1"></FileInput>
                    </div>
                    <error-messages-block :field="$v.idDocIndiv1">
                      <template #fileTypeValidation>{{ $t('profile.error.file_type', {param1: fileUploadExt}) }}
                      </template>
                      <template #fileSizeValidation>{{ $t('profile.error.file_size') }}</template>
                    </error-messages-block>
                  </div>
                  <div class="form-group row">
                    <label class="control-label col-sm-3 col-form-label">{{ $t("trs.front.crypto.upfile.select.file") }}</label>
                    <div class="col-sm-9">
                      <FileInput v-model="$v.idDocIndiv2.$model" name="idDocIndiv2"></FileInput>
                    </div>
                    <error-messages-block :field="$v.idDocIndiv2">
                      <template #fileTypeValidation>{{
                          $t('profile.error.file_type', {param1: fileUploadExt})
                        }}
                      </template>
                      <template #fileSizeValidation>{{ $t('profile.error.file_size') }}</template>
                    </error-messages-block>
                  </div>
                  <div class="form-group row">
                    <label class="control-label col-sm-3 col-form-label">{{
                        $t("trs.front.crypto.upfile.select.file")
                      }}</label>
                    <div class="col-sm-9">
                      <FileInput v-model="$v.idDocIndiv3.$model" name="idDocIndiv3"></FileInput>
                    </div>
                    <error-messages-block :field="$v.idDocIndiv3">
                      <template #fileTypeValidation>{{
                          $t('profile.error.file_type', {param1: fileUploadExt})
                        }}
                      </template>
                      <template #fileSizeValidation>{{ $t('profile.error.file_size') }}</template>
                    </error-messages-block>
                  </div>
                  <div class="text-center margin-btn">
                    <button type="submit" class="btn btn-success btn-md btn-submit-padding" :disabled="disableUploadIdDocIndivBtn">
                      {{ $t("trs.front.crypto.upfile.on.web") }}
                    </button>
                  </div>
                </form>
            </div>
          </div>
        </div>
      </div>

      <div v-if="isCustomerCorp">

        <!--  Identity Verification Docs : personal transaction -->
        <h4><span>{{ $t("trs.front.crypto.upfile.personal.transaction.docs") }}</span></h4>
        <div id="uploadPersonalTransPanel" class="panel-group card" :class="showUploadPersonalTransDoc ? 'open' : ''">
          <div class="panel-heading card-header"
               @click="toggleShowUploadPersonalTransFlg()"
               data-toggle="collapse" data-target="#uploadPersonalTransPanelBody"
               aria-expanded="true" aria-controls="uploadPersonalTransPanelBody">
            <i class="icon icon-upload"></i>
            <label><strong>{{ $t("trs.front.crypto.upfile.on.web") }}</strong></label>
            <i class="icon-arrow"></i>
          </div>
          <div id="uploadPersonalTransPanelBody" class="panel-body collapse" style="padding: 20px 0px 0px 0px" data-parent="#upFileTab1">
            <div class="card-body">
              <div style="margin-bottom: 20px">{{ $t("trs.front.crypto.upfile.corp.personal.transaction.file.extension") }}</div>
              <form name="personal_transaction" novalidate @submit.prevent="uploadPersonalTransDoc()">
                <div class="form-group row">
                  <label class="control-label col-sm-3 col-form-label">{{ $t("trs.front.crypto.upfile.select.file") }}</label>
                  <div class="col-sm-9">
                    <FileInput v-model="$v.personalTransDoc1.$model" name="personalTransDoc1"></FileInput>
                  </div>
                  <error-messages-block :field="$v.personalTransDoc1">
                    <template #fileTypeValidation>
                      {{ $t('profile.error.file_type', {param1: fileUploadExt}) }}
                    </template>
                    <template #fileSizeValidation>
                      {{ $t('profile.error.file_size') }}
                    </template>
                  </error-messages-block>
                </div>
                <div class="form-group row">
                  <label class="control-label col-sm-3 col-form-label">{{ $t("trs.front.crypto.upfile.select.file") }}</label>
                  <div class="col-sm-9">
                    <FileInput v-model="$v.personalTransDoc2.$model" name="personalTransDoc2"></FileInput>
                  </div>
                  <error-messages-block :field="$v.personalTransDoc2">
                    <template #fileTypeValidation>
                      {{ $t('profile.error.file_type', {param1: fileUploadExt}) }}
                    </template>
                    <template #fileSizeValidation>
                      {{ $t('profile.error.file_size') }}
                    </template>
                  </error-messages-block>
                </div>
                <div class="text-center margin-btn">
                  <button type="submit" class="btn btn-success btn-md btn-submit-padding" :disabled="disableUploadPersonalTransBtn">
                      {{ $t("trs.front.crypto.upfile.on.web") }}
                    </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <p></p>

        <!-- Identity Verification Docs : Certificate of all history items -->
        <h4><span>{{ $t("trs.front.crypto.upfile.personal.certificate.history.docs") }}</span></h4>
        <div id="uploadCertHistoryPanel" class="panel-group card" :class="showUploadCertHistoryDoc ? 'open' : ''">
          <div class="panel-heading card-header"
               @click="toggleShowUploadCertHistoryFlg()"
               data-toggle="collapse" data-target="#uploadCertHistoryPanelBody"
               aria-expanded="true" aria-controls="uploadCertHistoryPanelBody">
            <i class="icon icon-upload"></i>
              <label><strong>{{ $t("trs.front.crypto.upfile.on.web") }}</strong></label>
            <i class="icon-arrow"></i>
          </div>
          <div id="uploadCertHistoryPanelBody" class="panel-body collapse" style="padding: 20px 0px 0px 0px" data-parent="#upFileTab1">
            <div class="card-body">
              <div style="margin-bottom: 20px">{{ $t("trs.front.crypto.upfile.corp.personal.certificate.history.file.extension") }}</div>
              <form name="certificate_history" novalidate @submit.prevent="uploadCertHistoryDoc()">
                <div class="form-group row">
                  <label class="control-label col-sm-3 col-form-label">{{ $t("trs.front.crypto.upfile.select.file") }}</label>
                  <div class="col-sm-9">
                    <FileInput v-model="$v.certHistory1.$model" name="certHistory1"></FileInput>
                  </div>
                  <error-messages-block :field="$v.certHistory1">
                    <template #fileTypeValidation>
                      {{ $t('profile.error.file_type', {param1: fileUploadExt}) }}
                    </template>
                    <template #fileSizeValidation>
                      {{ $t('profile.error.file_size') }}
                    </template>
                  </error-messages-block>
                </div>
                <div class="form-group row">
                  <label class="control-label col-sm-3 col-form-label">{{ $t("trs.front.crypto.upfile.select.file") }}</label>
                  <div class="col-sm-9">
                    <FileInput v-model="$v.certHistory2.$model" name="certHistory2"></FileInput>
                  </div>
                  <error-messages-block :field="$v.certHistory2">
                    <template #fileTypeValidation>
                      {{ $t('profile.error.file_type', {param1: fileUploadExt}) }}
                    </template>
                    <template #fileSizeValidation>
                      {{ $t('profile.error.file_size') }}
                    </template>
                  </error-messages-block>
                </div>
                <div class="text-center margin-btn">
                  <button type="submit" class="btn btn-success btn-md btn-submit-padding" :disabled="disableUploadCertHistoryBtn">
                      {{ $t("trs.front.crypto.upfile.on.web") }}
                    </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <p></p>

      <!-- My Number Docs -->
      <div v-if="enableUploadMyNumberDoc">
        <div v-if="isCustomerIndividual">
          <h4 style="margin-top: 0"><span>{{ $t("trs.front.crypto.upfile.mynumber.docs") }}</span></h4>
        </div>
        <div v-if="isCustomerCorp">
          <h4><span>{{ $t("trs.front.crypto.upfile.corp.mynumber.docs") }}</span></h4>
        </div>

        <div id="uploadMyNumberPanel" class="panel-group card" :class="showUploadMyNumberDoc ? 'open' : ''">
          <div class="panel-heading"
               @click="toggleShowUploadMyNumberFlg()"
               data-toggle="collapse" data-target="#uploadMyNumberPanelBody"
               aria-expanded="true" aria-controls="uploadMyNumberPanelBody">
            <i class="icon icon-upload"></i>
            <label><strong>{{ $t("trs.front.crypto.upfile.on.web") }}</strong></label>
            <i class="icon-arrow"></i>
          </div>
          <div id="uploadMyNumberPanelBody" class="panel-body collapse" style="padding: 20px 0px 0px 0px" data-parent="#upFileTab1">
            <div class="card-body">
              <div v-if="isCustomerIndividual">
                <div style="margin-bottom: 20px">{{ $t("trs.front.crypto.upfile.indiv.mynumber.file.extension") }}</div>
              </div>
              <div v-if="isCustomerCorp">
                <div style="margin-bottom: 20px">{{ $t("trs.front.crypto.upfile.corp.mynumber.file.extension") }}</div>
              </div>
              <form name="my_number" novalidate @submit.prevent="uploadMyNumberDoc()">
                <div class="form-group row">
                  <label class="control-label col-sm-3 col-form-label">{{ $t("trs.front.crypto.upfile.select.file") }}</label>
                  <div class="col-sm-9">
                    <FileInput v-model="$v.myNumber1.$model" name="myNumber1"></FileInput>
                  </div>
                  <error-messages-block :field="$v.myNumber1">
                    <template #fileTypeValidation>{{ $t('profile.error.file_type', {param1: fileUploadExt}) }}</template>
                    <template #fileSizeValidation>{{ $t('profile.error.file_size') }}</template>
                  </error-messages-block>
                </div>
                <div class="form-group row">
                  <label class="control-label col-sm-3 col-form-label">{{ $t("trs.front.crypto.upfile.select.file") }}</label>
                  <div class="col-sm-9">
                    <FileInput v-model="$v.myNumber2.$model" name="myNumber2"></FileInput>
                  </div>
                  <error-messages-block :field="$v.myNumber2">
                    <template #fileTypeValidation>{{ $t('profile.error.file_type', {param1: fileUploadExt}) }}</template>
                    <template #fileSizeValidation>{{ $t('profile.error.file_size') }}</template>
                  </error-messages-block>
                </div>
                <div class="text-center margin-btn">
                  <button type="submit" class="btn btn-success btn-md btn-submit-padding" :disabled="disableUploadMyNumberBtn">
                    {{ $t("trs.front.crypto.upfile.on.web") }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div id="upFileTab2" class="tab_content" v-show="activeTab === 1">
      <ul class="content-fax">
        <li>
          <div class="title-box icon-address">
            <div style="width: 100px; margin-left: 10px;">{{ $t('label.cryptoRegistration.deliveryAddressTitle')}}</div>
          </div>
          <div v-html="$t('label.cryptoRegistration.deliveryContent', {
            company_zipcode: postDocTemplate?.postDocZipCode,
            company_address_1: postDocTemplate?.postDocStreetAddress,
            company_address_2: postDocTemplate?.postDocBuildingAddress,
            company_name: postDocTemplate?.postDocCompanyName }
            )"></div>
        </li>
      </ul>
      <br>
      <ul style="text-align: center; padding: 0">
        {{ $t('label.cryptoRegistration.deliveryNote') }}<a :href="supportDocumentUrl" target="_blank">こちら</a>をご確認ください。
      </ul>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
import $ from "jquery";
import FileInput from '@/components/base/FileInput';
import ValidationUtils from "@/common/utils/ValidationUtils.js";
import cryptoRedirectMixin from '@/common/mixins/cryptoRedirect';
import {fileSizeValidation, fileTypeValidation} from '@/common/helpers/validation';
import * as TYPE from '@/store/modules/crypto-registration/type';
import {MENU_CRYPTO, SET_ACTIVE_TAB_ID} from '@/store/modules/header/type';
import Config from "@/services/Config";

const {mapState: mapCryptoRegistrationState, mapActions: mapCryptoRegistrationAction} = createNamespacedHelpers('cryptoRegistration');
const {mapState: mapHeaderState, mapActions: mapHeaderActions} = createNamespacedHelpers('header');

export default {
    mixins:[cryptoRedirectMixin],
    components: {
        FileInput
    },
    data() {
        return {
            SERVICE_NAME: "cryptoRegistration",
            supportDocumentUrl : Config.getSupportDocumentUrl(),
            activeTab: 0,

            showUploadIdDoc: false,
            idDocIndiv1: null,
            idDocIndiv2: null,
            idDocIndiv3: null,

            showUploadPersonalTransDoc: false,
            personalTransDoc1: null,
            personalTransDoc2: null,

            showUploadCertHistoryDoc: false,
            certHistory1: null,
            certHistory2: null,

            showUploadMyNumberDoc: false,
            myNumber1: null,
            myNumber2: null,

            successMessage: null,
            errorMessage: null,
        }
    },
    validations() {
        const fileValidator = {
            fileTypeValidation, fileSizeValidation
        };

        if (this.isCustomerIndividual) {
            return {
                idDocIndiv1: {
                    ...fileValidator
                },
                idDocIndiv2: {
                    ...fileValidator
                },
                idDocIndiv3: {
                    ...fileValidator
                },
                myNumber1: {
                    ...fileValidator
                },
                myNumber2: {
                    ...fileValidator
                }
            }
        } else {
            return {
                personalTransDoc1: {
                    ...fileValidator
                },
                personalTransDoc2: {
                    ...fileValidator
                },
                certHistory1: {
                    ...fileValidator
                },
                certHistory2: {
                    ...fileValidator
                },
                myNumber1: {
                    ...fileValidator
                },
                myNumber2: {
                    ...fileValidator
                }
            }
        }
    },
    created() {
        this[TYPE.INIT_CRYPTO_REGISTRATION_FLAGS]();
        this[SET_ACTIVE_TAB_ID](MENU_CRYPTO);
        this.redirectCryptoRegistration();
    },
    computed: {
        ...mapCryptoRegistrationState({
            myNumberStatus: state => state.myNumberStatus,
            cryptoMailConfirmScript: state => state.cryptoMailConfirmScript
        }),

        ...mapHeaderState({
            corpType: state => state.headerInfo.corporationType,
            validFileExtension: state => state.headerInfo.fileUploadExt,
        }),

        isCustomerIndividual: function () {
            return this.corpType === 0;
        },

        isCustomerCorp: function () {
            return this.corpType === 1;
        },

        enableUploadMyNumberDoc: function () {
            return this.myNumberStatus !== 1;
        },

        fileUploadExt: function () {
            return this.validFileExtension;
        },

        disableUploadIdDocIndivBtn() {
            if (this.idDocIndiv1 === null && this.idDocIndiv2 === null && this.idDocIndiv3 === null) {
                return true;
            }

            if (this.idDocIndiv1 !== null) {
                this.$v.idDocIndiv1.$touch();
                if (this.$v.idDocIndiv1.$error) {
                    return true;
                }
            }

            if (this.idDocIndiv2 !== null) {
                this.$v.idDocIndiv2.$touch();
                if (this.$v.idDocIndiv2.$error) {
                    return true;
                }
            }

            if (this.idDocIndiv3 !== null) {
                this.$v.idDocIndiv3.$touch();
                if (this.$v.idDocIndiv3.$error) {
                    return true;
                }
            }

            return false;
        },

        disableUploadMyNumberBtn() {
            if (this.myNumber1 === null && this.myNumber2 === null) {
                return true;
            }

            if (this.myNumber1 !== null) {
                this.$v.myNumber1.$touch();
                if (this.$v.myNumber1.$error) {
                    return true;
                }
            }

            if (this.myNumber2 !== null) {
                this.$v.myNumber2.$touch();
                if (this.$v.myNumber2.$error) {
                    return true;
                }
            }

            return false;
        },

        disableUploadPersonalTransBtn() {
            if (this.personalTransDoc1 === null && this.personalTransDoc2 === null) {
                return true;
            }

            if (this.personalTransDoc1 !== null) {
                this.$v.personalTransDoc1.$touch();
                if (this.$v.personalTransDoc1.$error) {
                    return true;
                }
            }

            if (this.personalTransDoc2 !== null) {
                this.$v.personalTransDoc2.$touch();
                if (this.$v.personalTransDoc2.$error) {
                    return true;
                }
            }

            return false;
        },

        disableUploadCertHistoryBtn() {
            if (this.certHistory1 === null && this.certHistory2 === null) {
                return true;
            }

            if (this.certHistory1 !== null) {
                this.$v.certHistory1.$touch();
                if (this.$v.certHistory1.$error) {
                    return true;
                }
            }

            if (this.certHistory2 !== null) {
                this.$v.certHistory2.$touch();
                if (this.$v.certHistory2.$error) {
                    return true;
                }
            }

            return false;
        }
    },
    watch: {
        cryptoMailConfirmScript() {
            if (!ValidationUtils.isNull(this.cryptoMailConfirmScript)) {
              $("#trs-wrapper").prepend(this.cryptoMailConfirmScript);
            }
        }
    },
    methods: {
        ...mapCryptoRegistrationAction([
            TYPE.INIT_CRYPTO_REGISTRATION_FLAGS
        ]),

        ...mapHeaderActions([
            SET_ACTIVE_TAB_ID
        ]),

        async uploadIdDocIndiv() {
            this.successMessage = null;

            let formData = new FormData();
            formData.append("fileUploades", this.idDocIndiv1);
            formData.append("fileUploades", this.idDocIndiv2);
            formData.append("fileUploades", this.idDocIndiv3);
            formData.append('propertyFile', 'VERIFICATION_DOCS');

            await this.handleFormData(formData);
        },

        async uploadMyNumberDoc() {
            this.successMessage = null;

            let formData = new FormData();
            formData.append("fileUploades", this.myNumber1);
            formData.append("fileUploades", this.myNumber2);
            formData.append('propertyFile', 'MY_NUMBER');

            await this.handleFormData(formData);
        },

        async uploadPersonalTransDoc() {
            this.successMessage = null;

            let formData = new FormData();
            formData.append("fileUploades", this.personalTransDoc1);
            formData.append("fileUploades", this.personalTransDoc2);
            formData.append('propertyFile', 'VERIFICATION_DOCS');

            await this.handleFormData(formData);
        },

        async uploadCertHistoryDoc() {
            this.successMessage = null;

            let formData = new FormData();
            formData.append("fileUploades", this.certHistory1);
            formData.append("fileUploades", this.certHistory2);
            formData.append('propertyFile', 'VERIFICATION_DOCS');

            await this.handleFormData(formData);
        },

        async handleFormData(formData) {
            try {
                const uploadFileResponse = await this.$service.getService(this.SERVICE_NAME).uploadFile(formData);

                if (uploadFileResponse) {
                    // hot fix for axios Network Error, because it isn't caught by catch block
                    if (uploadFileResponse.message === 'Network Error') {
                        this.errorMessage = "MSG_TRS_NAF_0151";
                        return;
                    }

                    // case client tries to break constraint input
                    if (uploadFileResponse.status === 406) {
                        this.errorMessage = uploadFileResponse.data.errorMessage;
                        return;
                    }

                    this.successMessage = uploadFileResponse.successMessage;
                    this.errorMessage = uploadFileResponse.errorMessage;
                    this.clearAllFileInput();
                }
            } catch (e) {
                this.errorMessage = "MSG_TRS_NAB_0016";
            }
        },

        clearAllFileInput: function () {
            $('.custom-file').each(function () {
                const buttonFileGroup = $(this).next()
                if (buttonFileGroup.length > 0) {
                    buttonFileGroup.find('button:last-child').trigger('click');
                }
            })
        },

        updateActiveUploadFileTab: function (tabNo) {
            this.activeTab = tabNo;
        },

        toggleShowUploadIdDocFlg: function () {
            this.showUploadIdDoc = !this.showUploadIdDoc;

            // trigger other flags
            this.showUploadMyNumberDoc = false;
        },

        toggleShowUploadMyNumberFlg: function () {
            this.showUploadMyNumberDoc = !this.showUploadMyNumberDoc;

            // trigger other flags
            this.showUploadIdDoc = false;
            this.showUploadPersonalTransDoc = false;
            this.showUploadCertHistoryDoc = false;
        },

        toggleShowUploadPersonalTransFlg: function () {
            this.showUploadPersonalTransDoc = !this.showUploadPersonalTransDoc;

            // trigger other flags
            this.showUploadMyNumberDoc = false;
            this.showUploadCertHistoryDoc = false;
        },

        toggleShowUploadCertHistoryFlg: function () {
            this.showUploadCertHistoryDoc = !this.showUploadCertHistoryDoc;

            // trigger other flags
            this.showUploadMyNumberDoc = false;
            this.showUploadPersonalTransDoc = false;
        },
    },
}
</script>

<style scoped>
p {
  margin: 0px 15px 20px;
}

@media ( max-width: 480px) {
  .margin-btn {
    margin: 30px 15px 0px;
  }
}
</style>
